import React from "react"
import { View, Text, ActivityIndicator } from "./primitives"
import { appFixedViewportStyle } from "./app-shell"

export default function SpinnerOverlay({
  visible,
  textContent,
}: {
  visible?: boolean
  textContent?: string
}) {
  if (!visible) return null
  return (
    <View
      style={{
        ...appFixedViewportStyle,
        zIndex: 99999,
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(0,0,0,0.35)",
      }}
    >
      <ActivityIndicator size="large" color="#fff" />
      {textContent ? <Text style={{ color: "#fff", marginTop: 12 }}>{textContent}</Text> : null}
    </View>
  )
}
